import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { formatDateMedium } from '../../helpers/datetime';
import useTranslate from '../../hooks/useTranslate';
import getInspirationUrl from '../../services/apis/inspirations/getInspirationUrl';
import { InspirationType } from '../../services/apis/inspirations/types';
import styles from './InspirationListItem.module.scss';

interface InspirationItemMainProps {
  inspiration: InspirationType;
}

const InspirationItemMain: FC<InspirationItemMainProps> = props => {
  const { inspiration } = props;
  const { translate, activeLanguage } = useTranslate();

  return (
    <div className={styles.main}>
      <div>
        <h2>
          <NavLink to={getInspirationUrl(inspiration)}>{inspiration.title}</NavLink>
        </h2>
        <div dangerouslySetInnerHTML={{ __html: inspiration.preamble }} />
        <p className="text-muted">
          <NavLink to={`?category=${inspiration.category}`} className="fw-bold">
            {String(translate(`Inspirations.categories.${inspiration.category}`))}
          </NavLink>
          &emsp;&emsp;
          {formatDateMedium(inspiration.releaseDate, activeLanguage.code)}
          &emsp;&emsp;
          {inspiration.readTime > 0 && `${inspiration.readTime} min read`}
        </p>
      </div>
      <NavLink to={getInspirationUrl(inspiration)}>
        <img
          src={inspiration.imageUrl || 'about:blank'}
          alt={inspiration.title}
          className={styles.image}
        />
      </NavLink>
    </div>
  );
};

export default InspirationItemMain;
